import {
  FETCH_ADDRESS_SUCCESS,
  FETCH_ADDRESS_FAIL,
  CREATE_ADDRESS_SUCCESS,
  CREATE_ADDRESS_FAIL,
  WITHDRAW_FUNDS_SUCCESS,
  WITHDRAW_FUNDS_FAIL,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_FAIL,
  FETCH_WITHDRAWAL_FEES_SUCCESS,
  FETCH_WITHDRAWAL_FEES_FAIL,
  APPROVE_WITHDRAWAL_SUCCESS,
  APPROVE_WITHDRAWAL_FAIL,
  DENY_WITHDRAWAL_SUCCESS,
  DENY_WITHDRAWAL_FAIL,
  FETCH_APPROVALS_SUCCESS,
  FETCH_APPROVALS_FAIL,
} from '../actions/types';

const initialState = {
  coins: {},
  withdrawFee: {},
  transactions: {},
  approvals: [],
  errors: [],
  success: [],
};

const coins = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADDRESS_SUCCESS:
      return {
        ...state,
        coins: action.payload,
        loading: false,
      };
    case FETCH_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_ADDRESS_SUCCESS:
      return {
        ...state,
        coins: action.payload,
        loading: false,
        errors: [],
      };
    case CREATE_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case WITHDRAW_FUNDS_SUCCESS:
      return {
        ...state,
        coins: action.payload,
        success: {
          success: [action.payload.message],
          needsConfirmation: action.payload.needsConfirmation,
        },
        errors: [],
        loading: false,
      };
    case WITHDRAW_FUNDS_FAIL:
      return {
        ...state,
        loading: false,
        success: [],
        errors: action.errors.response.data,
      };
    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.payload,
        loading: false,
      };
    case FETCH_TRANSACTIONS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case FETCH_WITHDRAWAL_FEES_SUCCESS:
      return {
        ...state,
        withdrawFee: action.payload.data,
        loading: false,
      };
    case FETCH_WITHDRAWAL_FEES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case APPROVE_WITHDRAWAL_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message || action.payload.data.message || 'Withdrawal Successfully Approved'] },
        errors: [],
        loading: false,
      };
    case APPROVE_WITHDRAWAL_FAIL:
      return {
        ...state,
        loading: false,
        success: [],
        errors: action.errors.response.data,
      };
    case DENY_WITHDRAWAL_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message || action.payload.data.message || 'Withdrawal Successfully Denied'] },
        errors: [],
        loading: false,
      };
    case DENY_WITHDRAWAL_FAIL:
      return {
        ...state,
        loading: false,
        success: [],
        errors: action.errors.response.data,
      };
    case FETCH_APPROVALS_SUCCESS:
      return {
        ...state,
        approvals: action.payload.approvals,
        loading: false,
      };
    case FETCH_APPROVALS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    default:
      return state;
  }
};

export default coins;
